/* Layout */
import Layout from '../views/admin/layout/Layout'
import testLayout from '../views/admin/layout/testLayout'

const asyncRouterMap = [
  /*   ========  ========  ======== */
  /*  ======== E-HAILING ======== */
  /* ========  ========  ======== */
  {
    path: '/z/:branchId/ehailing/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'ehailing', title: 'EHailing' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/profil_ehailing'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['Owner'], feature: 'ehailing', title: 'Fleet Card' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/ehailing/maklumatfleetcardsemasa_ehailing'),
        meta: { title: 'Maklumat Fleet Card Semasa' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/ehailing/permohonantambahkenderaan_ehailing'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'pemandu',
        component: () => import('@/views/ehailing/senaraipemandu_ehailing'),
        meta: { title: 'Senarai Pemandu' }
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/ehailing/mulatambahsyarikatminyak_ehailing'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'permohonantambahkenderaan-duplicate',
      //   component: () => import('@/views/ehailing/permohonantambahkenderaan-duplicate'),
      //   meta: { title: 'DUPLICATE Permohonan Tambah Kenderaan' }
      // },
      // {
      //   path: 'testfile',
      //   component: () => import('@/views/ehailing/testfile'),
      //   meta: { title: 'Testfile' }
      // },
      // {
      //   path: 'senaraifleetcard',
      //   component: () => import('@/views/ehailing/senaraifleetcard_ehailing'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/ehailing/permohonanpertukaransyarikatminyak_ehailing'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
      
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/ehailing/rayuan_ehailing'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/ehailing/keduatukarsyarikatminyak_ehailing'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'cawanganuser'], feature: 'ehailing', title: 'Halaman Utama' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/dashboardduplicate_ehailing2'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'ehailing', title: 'Pengguna' },
    children: [
      // {
      //   path: 'senaraipengguna_all',
      //   component: () => import('@/views/ehailing/senaraipengguna_all_ehailing'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Awam [Semua]' }
      // },
      {
        path: 'senaraipengguna',
        component: () => import('@/views/ehailing/senaraipengguna_ehailing'),
        meta: { title: 'Pengguna Awam' }
      },
      {
        path: 'senaraikementerian',
        component: () => import('@/views/ehailing/senaraikementerian_ehailing'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Dalaman KPDN' }
      },
      // {
      //   path: 'senaraiagensi',
      //   component: () => import('@/views/ehailing/senaraiagensi_ehailing'),
      //   meta: { title: 'Pengguna Agensi' }
      // },
      {
        path: 'senaraisyarikatminyak',
        component: () => import('@/views/ehailing/senaraisyarikatminyak_ehailing'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Syarikat Minyak' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'ehailing', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/ehailing/pemegangakaun_ehailing'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/ehailing/physicalfleetcardadmin_ehailing'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      // {
      //   path: 'kuota_tambahan',
      //   component: () => import('@/views/ehailing/kuota_tambahan_ehailing'),
      //   meta: { title: 'Kuota Tambahan' }
      // },
      // {
      //   path: 'pembatalan_kuota',
      //   component: () => import('@/views/ehailing/pembatalan_kuota_ehailing'),
      //   meta: { title: 'Pembatalan Kuota' }
      // },
      {
        path: 'pertukaransyarikatminyak',
        component: () => import('@/views/ehailing/pertukaransyarikatminyak_ehailing'),
        meta: { title: 'Pertukaran Syarikat Minyak' },
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/ehailing/fleetcardvehicleappeals_ehailing'),
      //   meta: { title: 'Rayuan' }
      // },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/ehailing/kuotatambahan_ehailing'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Kuota Tambahan' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/ehailing/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/ehailing/fleetcardvehicleappeals_ehailing'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/ehailing/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'menu_kuota_tambahan',
      //   component: () => import('@/views/ehailing/halamanutama_ehailing'),
      //   meta: { title: 'Tetapan Menu Kuota Tambahan' },
      // },
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/ehailing/tetapanrekodpenggunaan_ehailing'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/ehailing/detailrekodpenggunaan_ehailing'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_ehailing'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/ehailing/tetapanjenisbadan_ehailing'),
        meta: { title: 'Tetapan Jenis Badan' },
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/ehailing/tetapanjeniskegunaan_ehailing'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/ehailing/dashboardtetapanjenisbadan_ehailing'),
        meta: { title: 'Tetapan Deskripsi Umum (Halaman Utama)' },
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/ehailing/kandunganportal_ehailing'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/ehailing/kandunganbanner_ehailing'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/ehailing/senaraisekatan_ehailing'),
        meta: { title: 'Senarai Sekatan' }
      },
      // {
      //   path: 'sejarahsekatan',
      //   component: () => import('@/views/ehailing/sejarahsekatan_ehailing'),
      //   meta: { title: 'Sejarah Sekatan' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/ehailing/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/ehailing/halamanutama_ehailing'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/ehailing/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/ehailing/halamanutama_ehailing'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/ehailing/search',
    component: Layout,
    redirect: '',
    name: 'Carian',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'ehailing', title: 'Carian' },
    children: [
      {
        path: 'jpj',
        component: () => import('@/views/ehailing/searchjpj_ehailing'),
        meta: { title: 'Rekod Kenderaan' },
      },
      {
        path: 'ssm',
        component: () => import('@/views/ehailing/searchssm_ehailing'),
        meta: { title: 'Semakan Data Syarikat' },
      },
      {
        path: 'jpn',
        component: () => import('@/views/ehailing/searchjpn_ehailing'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Semakan Data Pemilikan Tunggal' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/laporan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'ehailing', title: 'Laporan' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/laporan_ehailing'),
        meta: { title: 'Laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/testpage',
    component: testLayout,
    redirect: '',
    name: 'Test Page',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Test Page' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/testpage'),
        meta: { title: 'Test Page' }
      },
    ],
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/ehailing/kpdnprofil',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'ehailing', title: 'Profil' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/kpdnprofil_ehailing'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/systemsettingsnextlevel',
    component: Layout,
    redirect: '',
    name: 'Tetapan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Tetapan Sistem' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/systemsettings_ehailing'),
        meta: { title: 'Tetapan Sistem' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/vehicleownershipchanges',
    component: Layout,
    redirect: '',
    name: 'Log Tukar Hak Milik',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Log Tukar Hak Milik' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/vehicleownershipchange_ehailing'),
        meta: { title: 'Log Tukar Hak Milik' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/manual',
    component: Layout,
    redirect: '',
    name: 'Manual',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Manual' },
    children: [
      {
        path: 'manualpegawai',
        component: () => import('@/views/ehailing/blank_ehailing'),
        meta: { title: 'Manual Pegawai' },
      },
      {
        path: 'manualpengguna',
        component: () => import('@/views/ehailing/blank_ehailing'),
        meta: { title: 'Manual Pengguna' },
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/ehailing/testing',
  //   component: Layout,
  //   redirect: '',
  //   name: 'TESTING',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'TESTING' },
  //   children: [
  //     {
  //       path: 'testingssmcompanies',
  //       component: () => import('@/views/ehailing/testingssmcompanies_ehailing'),
  //       meta: { title: 'SSM Companies' },
  //     },
  //     {
  //       path: 'testingjpjcompanies',
  //       component: () => import('@/views/ehailing/testingjpjcompanies_ehailing'),
  //       meta: { title: 'JPJ Companies' },
  //     },
  //     {
  //       path: 'testingjpjvehicles',
  //       component: () => import('@/views/ehailing/testingjpjvehicles_ehailing'),
  //       meta: { title: 'JPJ Vehicles' },
  //     },
  //     {
  //       path: 'testingmyidentityindividuals',
  //       component: () => import('@/views/ehailing/testingmyidentityindividuals_ehailing'),
  //       meta: { title: 'myIDENTITY Individuals' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/ehailing/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'ehailing', title: 'EHailing' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/halamanutamaoilcompany_ehailing'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'ehailing', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/ehailing/pemegangakaunoilcompany_ehailing'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/ehailing/physicalfleetcardoilcompany_ehailing'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/ehailing/permohonanpertukaransyarikatminyakoilcompany_ehailing'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/rekodpenggunaan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'ehailing', title: 'Laporan' },
    children: [
      // {
      //   path: 'rekodpenggunaan',
      //   component: () => import('@/views/ehailing/rekodpenggunaanoilcompany'),
      //   meta: { title: 'Rekod Penggunaan' }
      // },
      {
        path: 'detailrekodpenggunaanoilcompany',
        component: () => import('@/views/ehailing/detailrekodpenggunaanoilcompany_uploadversion'),
        meta: { title: 'Laporan Penggunaan Kuota' }
      },
      {
        path: 'detailmonthquotaoilcompany',
        component: () => import('@/views/ehailing/detailmonthquotaoilcompany_ehailing'),
        meta: { title: 'Laporan Pemegang Akaun' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/ehailing/kuotatambahanoilcompany_ehailing'),
        meta: { title: 'Laporan Kuota Tambahan' }
      },
      // {
      //   path: 'percentagechangesoilcompany',
      //   component: () => import('@/views/ehailing/percentagechangesoilcompany'),
      //   meta: { title: 'Laporan Perubahan Kuota' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'ehailing', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/ehailing/senaraisekatanoilcompany_ehailing'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/banner',
    component: Layout,
    redirect: '',
    name: 'Senarai Banner',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Banner' },
    children: [
      {
        path: 'senaraibanner',
        component: () => import('@/views/ehailing/senaraibanner_ehailing'),
        meta: { title: 'Senarai Banner' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/lpagenerator',
    component: Layout,
    redirect: '',
    name: 'Jana LPA eHailing',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'Jana LPA eHailing' },
    children: [
      {
        path: 'lpagenerator',
        component: () => import('@/views/ehailing/lpagenerator_ehailing'),
        meta: { title: 'Jana LPA eHailing' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/mofgenerator',
    component: Layout,
    redirect: '',
    name: 'MOF Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'ehailing', title: 'MOF Generator' },
    children: [
      {
        path: 'mofgenerator',
        component: () => import('@/views/ehailing/mofgenerator_ehailing'),
        meta: { title: 'MOF Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/lpadownload',
    component: Layout,
    redirect: '',
    name: 'Muat Turun LPA eHailing',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'ehailing', title: 'Muat Turun LPA eHailing' },
    children: [
      {
        path: 'lpadownload',
        component: () => import('@/views/ehailing/lpadownload_ehailing'),
        meta: { title: 'Muat Turun LPA eHailing' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/ehailing/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['enforcer'], feature: 'ehailing', title: 'Sekatan' },
    children: [
      {
        path: '',
        component: () => import('@/views/ehailing/senaraisekatan_ehailing'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
]

export default asyncRouterMap



// WEBPACK FOOTER //
// ./src/router/ehailing.js